module.exports = __webpack_public_path__ + "img/462.2f31f1aa.jpg";